var React = require('react');

function Minimize (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 14H10V20","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3 21L10 14","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M20 10H14V4","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M14 10L21 3","stroke":"#8B929A","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Minimize.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Minimize;

Minimize.default = Minimize;
